// The message a team leader sends with a team invitation link. Written to read
// well pasted into WhatsApp (plain text, short lines), and edited by the leader
// before it goes. It deliberately names no sender: it is in the first person, so
// whoever it is passed on to can forward it and it reads as coming from them.

// "Thursday 22 October"
export const formatEndDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });

export const buildInviteMessage = ({ teamName, url, expiresAt }) => {
  const team = (teamName || "").trim() || "our team";
  const lines = [
    `Hi! I'd like you to join ${team} on PlanPraise, where our worship team keeps our songs, lyrics and setlists in one place.`,
    "",
    `1. Open this link: ${url}`,
    `2. Create an account (email and password, or Google/Microsoft). You'll be added to ${team} automatically.`,
    "3. Tip: add PlanPraise to your home screen when it offers, so it opens like an app.",
    "",
    "Already have an account? Sign in and use the same link.",
    // Not "ask me": the message may have been passed on by someone who can't
    // make a new link.
    expiresAt
      ? `The link works until ${formatEndDate(expiresAt)}. If it has expired, ask your team leader for a new one.`
      : "If the link has expired, ask your team leader for a new one.",
  ];
  return lines.join("\n");
};

export const inviteSubject = (teamName) => `Join ${(teamName || "").trim() || "our team"} on PlanPraise`;

export const whatsappLink = (message) => `https://wa.me/?text=${encodeURIComponent(message)}`;

export const emailLink = (subject, message) =>
  `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
